import styled from "styled-components"
import { Chart_Percent } from "../../../Chart/percent"
import { theme } from "../../../../styles/theme"

interface Props {
  score: number | null,
}

export const Section_History_SafetyScore = ({score}: Props) => {

  return (
    <SSection className="SafetyScore">
      <header>
        <label>안전운행점수</label>
      </header>

      <div className="value">
        <Chart_Percent percent={score || 0} />
        <span>{score == null ? "-" : `${score}점`}</span>
      </div>
    </SSection>
  )
}

const SSection = styled.section`

  & > .value {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: 100%;
    height: 220px;

    & > canvas {
      pointer-events: none;
    }
    & > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      font-weight: 600;
      line-height: 0;
      color: ${theme.colors.yellowgreen};
    }
  }
`